import { useMemo } from "react";

import { useCountries } from "../../../catalogs/countries";
import {
  NestedListItem,
  NestedListPicker,
  NestedListSelection,
} from "../../../components/ui-kit/nested-list-picker";
import { Location } from "./utils";

export function CountriesRegionsPicker(props: {
  locations: Location[];
  onChange: (locations: Location[]) => void;
}) {
  const countries = useCountries();

  // Convert Location[] to NestedListSelection format
  const selection = useMemo<NestedListSelection<string, number>[]>(() => {
    return props.locations.map((loc) => ({
      value: loc.country,
      children: loc.regions,
    }));
  }, [props.locations]);

  // Build items from countries registry
  const items = useMemo<NestedListItem<string, number>[]>(() => {
    return countries.countriesEnum.map((country) => {
      const regionsMap = countries.getRegionsMap(country);
      const children = Array.from(regionsMap.entries()).map(
        ([value, label]) => ({
          value,
          label,
        }),
      );

      return {
        value: country,
        label: country,
        children,
      };
    });
  }, [countries]);

  // Convert NestedListSelection back to Location[]
  const handleChange = (
    newSelection: NestedListSelection<string, number>[],
  ) => {
    const newLocations: Location[] = newSelection.map((sel) => ({
      country: sel.value,
      regions: sel.children,
    }));
    props.onChange(newLocations);
  };

  return (
    <NestedListPicker
      items={items}
      selection={selection}
      onChange={handleChange}
    />
  );
}
